import { Grid, Stack } from "@mui/system";
import VerticalLinearStepper from "../VerticalLinearStepper";

import { RecapCard } from "../../RecapCard";

export const IttechFfmpegRecap = () => {
  const blocks = [
    {
      label: "1. Container",
      image: "presentation-data/ITTECH2/recap/container.jpeg",
      reveal: "Het doosje waar streams in zitten (video, audio, subs)",
    },
    {
      label: "2. Demuxer & Muxer",
      image: "presentation-data/ITTECH2/recap/muxer.jpeg",
      reveal:
        "Uitpakken en inpakken van streams in een container | Demuxer -> Decoder > Encoder > Muxer",
    },
    {
      label: "3. Codec",
      image: "presentation-data/ITTECH2/recap/codec.jpeg",
      reveal:
        "Algoritme | Comprimeren & decomprimeren van audio/video > Bepaalt de eindkwaliteit",
    },
    {
      label: "4. Codec-bibliotheken",
      image: "presentation-data/ITTECH2/recap/libraries.jpeg",
      reveal:
        "De verzameling encoders/decoders die de codec daadwerkelijk uitvoeren. Bijvoorbeeld ingebouwd in VLC",
    },
    {
      label: "5. Filters",
      image: "presentation-data/ITTECH2/recap/filters.jpeg",
      reveal: "Bewerkingen zoals scale, crop, drawtext, fps",
    },
    {
      label: "6. Transcoder",
      image: "presentation-data/ITTECH2/recap/transcoder.jpeg",
      reveal: "FFMpeg | Het proces als geheel: decoder + encoder.",
    },
  ];

  return (
    <VerticalLinearStepper
      steps={[
        {
          label: "🧠 Recap",
          description: ``,
          content: (
            <Stack gap={5}>
              <Grid container spacing={2}>
                {blocks.map((x) => (
                  <Grid size={3}>
                    <RecapCard key={x.label} subject={x} />
                  </Grid>
                ))}
              </Grid>
            </Stack>
          ),
        },
        {
          label: "👨🏼‍💻 FFMpeg & Powershell",
          description: ``,
          content: <>Praktijkvoorbeelden</>,
        },
        {
          label: "📝 Start met: H4 | FFMPEG GEBRUIKEN",
          description: ``,
          content: <></>,
        },
      ]}
    />
  );
};
